import { Loader } from "@googlemaps/js-api-loader";
import { Env } from "./utils/env";

let loader = null;

export function makeGMapApiLoader(options) {
  if (Env.isServer()) {
    return {
      importLibrary: async () => {
        throw new Error("Cannot use Google Maps API on the server.");
      },
    };
  }

  return {
    async importLibrary(name) {
      if (!loader) {
        loader = new Loader({
          apiKey: options.key,
          version: options.version || "weekly",
          libraries: options.libraries || [],
        });
      }

      return await loader.importLibrary(name);
    },
  };
}
